import { EntRole } from "./role";
import { EntPositions } from "./handBooks/positions";
import { EntGovernment } from "./handBooks/government";
import { EntRoleAvailableRoutes } from "./rolesAvailableRoutes";

export class EntUser {
  id: number;
  pin: string;
  secondName: string;
  name: string;
  patronymic: string;
  password: string;
  temporaryAccessUntilTime: any | null;
  roleIds: number[] | null;
  roles: EntRole[] | null;
  availableRoutes?: EntRoleAvailableRoutes | null;
  position: EntPositions | null;
  email: string | null;
  phone: string | null;
  positionId: number | null;
  departmentId: number | null;
  governmentId: number | null;
  passwordChangeNextLogon: boolean | false;
  isBanned?: boolean | false;
  government?: EntGovernment | null;
  passwordLength?: number | null;

  constructor(){
    this.id = 0
    this.pin = "";
    this.password = "";
    this.name = "";
    this.secondName = "";
    this.patronymic = "";
    this.email = "";
    this.phone = "";
    this.departmentId = null;
    this.governmentId = null;
    this.positionId = null;
    this.roles = null;
    this.position = null;
    this.roleIds = null;
    this.temporaryAccessUntilTime = null;
    this.passwordChangeNextLogon = false;
  }
}
